<template>
<v-dialog v-model="show" max-width="800" scrollable>
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on">
      <v-btn v-on="on" color="primary">Billing Config Tester</v-btn>
    </slot>
  </template>
  <v-card>
    <v-card-title>Billing Config Tester</v-card-title>
    <v-card-text>
      <i>This is a sample and you are setting its billable properties checking to see if the price comes out correctly and the correct package is selected.</i>
      <v-select v-if="config.billingPackages.length > 0" v-model="form.exclude_packages" label="Exclude Packages" :items="config.billingPackages" item-text="name" item-value="uid"></v-select>
      <v-select v-model="form.category" label="Sample Category" :items="categories" item-value="uuid" item-text="name" clearable></v-select>
      <v-select v-model="form.customer" label="customers" :items="customers" item-text="primary_name.name" item-value="id" clearable></v-select>
      <v-select v-model="form.required_tests" label="Required Tests" :items="testTypes" return-object item-text="name" multiple clearable></v-select>
      <v-select v-model="form.flags" label="Flags" :items="flagTypes" return-object item-text="name" multiple clearable></v-select>
      <v-select v-model="form.promo" label="Promotional/Programs" :items="config.billingPromotions" item-text="name" return-object multiple clearable></v-select>
      <v-text-field v-model="form.percentDiscount" label="Percent Discount" suffix="%" clearable></v-text-field>
      <v-btn @click="calculate" color="success" class="mb-4">Calculate</v-btn>

      <v-card v-if="bill">
        <v-card-actions ><i class="title">Receipt</i></v-card-actions>
        <v-divider></v-divider>
        <v-simple-table dense>
          <tbody>
            <tr>
              <td>Selected package</td>
              <td>{{bill.package ? bill.package.name : 'None'}}</td>
            </tr>
            <tr><td colspan="2"><strong>Required tests</strong></td></tr>
            <tr v-for="test in bill.tests" :key="test.name">
              <td>{{test.name}}</td>
              <td>${{test.basePrice}}</td>
            </tr>
            <tr>
              <td colspan="2">
                <v-divider></v-divider>
              </td>
            </tr>
            <tr>
              <td><strong>Base Total</strong></td>
              <td><strong>${{bill.basePrice}}</strong></td>
            </tr>
            <tr>
              <td colspan="2">
                <v-divider></v-divider>
              </td>
            </tr>
            <tr v-if="bill.extra_costs.length > 0">
              <td><strong>Additions</strong></td>
              <td>
              </td>
            </tr>
            <tr v-if="bill.extra_costs.length > 0" v-for="(cost, index) in bill.extra_costs" :key="index+'extra'">
              <td>{{cost.name}}</td>
              <td> ${{cost.additional_cost}}</td>
            </tr>
            <tr v-if="bill.extra_costs.length > 0">
              <td colspan="2">
                <v-divider></v-divider>
              </td>
            </tr>
            <tr v-if="bill.discounts.length > 0">
              <td><strong>Discounts</strong></td>
              <td>
              </td>
            </tr>
            <tr v-if="bill.discounts.length > 0" v-for="(discount, index) in bill.discounts" :key="index">
              <td>{{discount.name}}</td>
              <td>- ${{discount.discount}}</td>
            </tr>
            <tr v-if="bill.percentDiscount && !bill.subtotal">
              <td>Percent Discount</td>
              <td>- {{bill.percentDiscount}}</td>
            </tr>
            <tr v-if="bill.discounts.length > 0">
              <td colspan="2">
                <v-divider></v-divider>
              </td>
            </tr>
            <tr v-if="bill.subtotal">
              <td><strong>Sub Total</strong></td>
              <td><strong>${{ bill.subtotal }}</strong></td>
            </tr>
            <tr v-if="bill.subtotal && bill.afterSubtotal.length > 0" v-for="(discount, index) in bill.afterSubtotal" :key="index">
              <td>{{discount.name}}</td>
              <td>- ${{discount.discount}}</td>
            </tr>
            <tr v-if="bill.subtotal && bill.percentDiscount" :key="index">
              <td>Percent Discount</td>
              <td>- {{bill.percentDiscount}}</td>
            </tr>
            <tr v-if="bill.afterSubtotal.length > 0">
              <td colspan="2">
                <v-divider></v-divider>
              </td>
            </tr>
            <tr>
              <td><strong>Final Total</strong></td>
              <td><strong>${{ bill.finalPrice }}</strong></td>
            </tr>
            <tr v-if="seperatedBillingItems.length > 0">
              <td colspan="2">
                <v-divider></v-divider>
              </td>
            </tr>
            <tr v-if="seperatedBillingItems.length > 0">
              <td colspan="2">
                <strong>Separated Billing Items</strong>
              </td>
            </tr>
            <tr v-for="(item,index) in seperatedBillingItems" :key="`separated_items_${index}`">
              <td>{{ item.display_name }}</td>
              <td>${{ item.price }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
import BillSample from "@/views/Config/Lib/BillSample";
export default {
    name: "SampleTestBill",
    components: {},
    data: () => ({
      show: false,
      form: {
        exclude_packages: [],
        required_tests: [],
        category: [],
        flags: [],
        promo: null,
        percentDiscount: null,
        customer: null,
      },
      bill: null,
      seperatedBillingItems: [],
    }),
    props:{
      customers: {
        required: true,
      }
    },
    computed: {
      flagTypes(){
        return this.$store.$db().model('sampleFlagTypes').all();
      },
      testTypes(){
        return this.$store.$db().model('sampleTestTypes').all();
      },
      categories(){
        return this.$store.$db().model('sampleCertTypeCategories').all();
      },
      config(){
        return {
          billingBundleDiscounts: this.$store.$db().model('billingBundleDiscounts').query().orderBy("priority").all(),
          billingPackages: this.$store.$db().model('billingPackages').query().orderBy("priority").all(),
          billingTestPairs: this.$store.$db().model('billingTestPairs').all(),
          billingTestPrices: this.$store.$db().model('billingTestPrices').all(),
          billingPromotions: this.$store.$db().model('billingPromotions').all(),
          billingSpecials: this.$store.$db().model('billingSpecials').all(),
          billingFixedPrices: this.$store.$db().model('billingFixedPrices').query().orderBy("priority").all(),
          billingSeparatedItems: this.$store.$db().model('billingSeparatedItems').query().orderBy("priority").all(),
        }
      }
    },
    methods: {
      calculate(){
        let sample = {
          sample_cert_type: {category: {uuid: this.form.category}},
          sample_tests: this.form.required_tests.map(test => ({test_type: test, sample_test_type_uuid: test.uuid})),
          sample_flags: this.form.flags.map(flag => ({sample_flag_type_uuid: flag.uuid})),
          customer_id: this.form.customer,
        }
        let bill = new BillSample({
          ...this.config,
          billingPackages: this.form.exclude_packages.length > 0 ? this.config.billingPackages.filter(pack => !this.form.exclude_packages.includes(pack.uid)) : this.config.billingPackages.filter(pack => !pack.$softDelete),
        });
        this.bill = bill.samplePrice(sample, this.form.promo.map(pr => pr.imperative_name), this.form.percentDiscount);
        this.seperatedBillingItems = bill.seperatedBillingItems(sample.customer_id, sample.sample_tests, sample.sample_flags, sample.sample_cert_type.category.uuid);
      }
    }
}
</script>

<style scoped>

</style>
